import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.scss',
})
export class TagsComponent {
  tags = input<string[]>([]);
  removable = input(true);

  tagRemoved = output<number>();

  removeTag(index: number) {
    if (this.removable()) {
      this.tagRemoved.emit(index);
    }
  }
}
